// extracted by mini-css-extract-plugin
module.exports = {"sharedStyles":"\"../../themes/sharedStyles.module.css\"","span":"Span_span__1Lwbs sharedStyles_standardTextStructure__2HVr-"};